import {Injectable,} from '@angular/core';
import {HttpClient,} from '@angular/common/http';
import {Observable, tap,} from 'rxjs';
import {StringUtil, WindowService,} from '@services/index';
import {XmlMasterVO,} from '@models/index';

/**
 * マスターキャッシュサービス
 */
@Injectable({
  providedIn: 'root',
})
export class XmlMasterService {
  xmlMasterListByKey: Map<string, XmlMasterVO[]> = new Map<string, XmlMasterVO[]>();
  constructor(private http: HttpClient, private windowService: WindowService, private stringUtil: StringUtil) {}

  /**
   * [一般開発者利用可]
   * 汎用マスタ情報を照会する
   */
  getAndSaveXmlMasterMember(): Observable<XmlMasterVO[]> {
    return this.http.get<XmlMasterVO[]>('/xml-master-member').pipe(
      tap((xmlMasterList: XmlMasterVO[]) => {
        this.saveXmlMaster(xmlMasterList, 'xmlMasterMember');
      })
    );
  }

  /**
   * [一般開発者利用可]
   * 汎用マスタ情報を照会する
   */
  getAndSaveXmlMasterSettingItem(): Observable<XmlMasterVO[]> {
    return this.http.get<XmlMasterVO[]>('/xml-master-setting-item').pipe(
      tap((xmlMasterList: XmlMasterVO[]) => {
        this.saveXmlMaster(xmlMasterList, 'xmlMasterSettingItem');
      })
    );
  }

  /**
   * [一般開発者利用可]
   * 汎用マスタ情報を照会する
   */
  getAndSaveXmlMasterSettingObject(): Observable<XmlMasterVO[]> {
    return this.http.get<XmlMasterVO[]>('/xml-master-setting-object').pipe(
      tap((xmlMasterList: XmlMasterVO[]) => {
        this.saveXmlMaster(xmlMasterList, 'xmlMasterSettingObject');
      })
    );
  }

  /**
   * [一般開発者利用可]
   * 種別コードを元に汎用マスタのリストを取得する
   * @param name ファイル名
   * @param type キーLocalStorage
   */
  getXmlMasterListByName(name: string, type: string): XmlMasterVO[] | undefined {
    // タイプセッションのリストをリセット
    this.reSetXmlMaster(type);
    const result = this.xmlMasterListByKey.get(name);
    // XML情報が見つからなかった場合、エラーをThrowする。
    if (typeof result === 'undefined' || result.length === 0) {
      throw Error;
    }
    return result;
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ登録処理。
   * 種別コードで汎用マスタリストを取得するためのMapの作成と種別コード_表示コードで汎用マスタを
   * 取得するMapの作成を行う
   * @param xmlMstListObj 汎用マスターレコードオブジェクト
   * @param type キーLocalStorage
   * @private
   */
  private saveXmlMaster(xmlMstListObj: object, type: string): void {
    const xmlMstList: XmlMasterVO[] = Object.values(xmlMstListObj)[0];
    for (const index in xmlMstList) {
      xmlMstList[index].value = this.convertJsonObjectToString(xmlMstList[index].value);
    }

    this.windowService.setItemToLocalStorage(type, xmlMstList);
  }

  /**
   *  [一般開発者利用不可]
   * Jsonオブジェクトを文字列に変換する
   * @param value JsonObject
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  private convertJsonObjectToString(value: any): any {
    value = JSON.parse(value);
    for (const item1 in value) {
      for (const item2 in value[item1]) {
        if (value[item1][item2].length > 1 &&
            (value[item1][item2].indexOf('[ {') > -1
            || value[item1][item2].indexOf('{') > -1)) {
              value[item1][item2] = this.convertJsonObjectToString(value[item1][item2]);
        }
      }
    }

    return value;
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ設定処理。
   * 種別コード、表示コードでの取得用にMapの作成を行う
   * @param xmlMstList  汎用マスターレコードオブジェクト
   * @private
   */
  private setXmlMaster(xmlMstList: XmlMasterVO[]): void {
    this.xmlMasterListByKey = new Map<string, XmlMasterVO[]>();

    xmlMstList.forEach((xmlMst) => {
      const xmlMasterList = this.xmlMasterListByKey.has(xmlMst.name)
        ? <XmlMasterVO[]>this.xmlMasterListByKey.get(xmlMst.name)
        : [];
      xmlMasterList.push(xmlMst);
      this.xmlMasterListByKey.set(xmlMst.name, xmlMasterList);
    });
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ再取得登録処理。
   * Mapが未作成の場合、Sessionから情報取得しMapを再作成する
   * @param type  キーLocalStorage
   * @private
   */
  private reSetXmlMaster(type: string): void {
    const xmlMaster = this.windowService.getItemFromLocalStorage<XmlMasterVO[]>(type);
    if (xmlMaster) {
      this.setXmlMaster(xmlMaster);
    }
  }
}
